import { bfsUserWebHttp } from '@/utils/http/index';

/**
 * @description 创建系统公告
 * @api https://yapi.ops.yunlizhi.cn/project/349/interface/api/21741
 */
export function createSystemNotice(data) {
  return bfsUserWebHttp.post('/bfs_push/system_notice/create', data);
}

/**
 * @description 修改系统公告
 * @api https://yapi.ops.yunlizhi.cn/project/349/interface/api/21743
 */
export function updateSystemNotice(data) {
  return bfsUserWebHttp.post('/bfs_push/system_notice/update', data);
}

/**
 * @description 系统公告分页查询
 * @api https://yapi.ops.yunlizhi.cn/project/349/interface/api/21745
 */
export function getSystemNoticePage(data, query) {
  return bfsUserWebHttp.post('/bfs_push/system_notice/page', data, {
    params: {
      ...query,
    },
  });
}

/**
 * @description 系统公告列表查询
 * @api https://yapi.ops.yunlizhi.cn/project/349/interface/api/21747
 */
export function getSystemNoticeList(data, query) {
  return bfsUserWebHttp.post('/bfs_push/system_notice/list', data, {
    params: {
      ...query,
    },
  });
}

/**
 * @description 修改系统公告状态
 * @api https://yapi.ops.yunlizhi.cn/project/349/interface/api/21749
 */
export function changeSystemNoticeStatus(data) {
  return bfsUserWebHttp.post('/bfs_push/system_notice/change_status', data);
}

/**
 * @description 读取系统公告
 * @api https://yapi.ops.yunlizhi.cn/project/349/interface/api/21751
 */
export function readSystemNotice(data) {
  return bfsUserWebHttp.post('/bfs_push/system_notice/read', data);
}

/**
 * @description 操作日志
 * @api https://yapi.ops.yunlizhi.cn/project/349/interface/api/21783
 */
export function getSystemNoticeLog(data, query) {
  return bfsUserWebHttp.post('/bfs_push/system_notice/log', data, {
    params: {
      ...query,
    },
  });
}

/**
 * @description 查询odoo公司列表
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/25859
 */
export function getOdooCompany(data, query) {
  return bfsUserWebHttp.post('/bfs-user/odoo_company/list', data, {
    params: {
      ...query,
    },
  });
}
